import { EnvironmentProviders, Injector, Provider } from '@angular/core';

import {
  deviceManagerPreferenceInitializer,
  layoutMenuPreferenceInitializer,
  ndtCanvasPreferenceInitializer,
  networkSettingsDevicePreferenceInitializer,
  paletteManagerPreferenceInitializer,
  ROOT_PREFERENCE_TOKEN,
  tcgStateInitializer,
} from '@olympus/ngx-shared';

import { APP_PREFERENCE_INITIALIZERS, WindViewPreference, windViewPreferenceInitializer } from './core/app.preference';

export const preferenceProviders: (Provider | EnvironmentProviders)[] = [
  {
    provide: APP_PREFERENCE_INITIALIZERS,
    useValue: [
      windViewPreferenceInitializer,
      networkSettingsDevicePreferenceInitializer,
      ndtCanvasPreferenceInitializer,
      tcgStateInitializer,
      layoutMenuPreferenceInitializer,
      paletteManagerPreferenceInitializer,
      deviceManagerPreferenceInitializer,
    ],
  },
  {
    provide: ROOT_PREFERENCE_TOKEN,
    useFactory: (injector: Injector): WindViewPreference => injector.get<WindViewPreference>(WindViewPreference),
    deps: [Injector],
  },
];
